import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { PdfService } from '@cfp/shared/ui/pdf';
import { Button, ButtonStyle, Icon, IconName } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { LabelGroupDTO } from 'csr-asset-app';

@Component({
  selector: 'cfp-building-pdf-download-button',
  templateUrl: './building-pdf-download-button.html',
  imports: [Button, Icon, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingPdfDownloadButton {
  public readonly url = input.required<string>();
  public readonly fileName = input.required<string>();
  public readonly buttonText = input<string>('downloadReport');
  public readonly labelGroup = input.required<LabelGroupDTO>();
  public readonly dataAnalytics = input<string>();
  public readonly buttonStyle = input<ButtonStyle>('secondary');
  public readonly buttonOutline = input<boolean>(true);
  public readonly showIcon = input<boolean>(true);
  public readonly icon = input<IconName | undefined>(undefined);

  private readonly pdfService = inject(PdfService);

  protected download(): void {
    this.pdfService.download(this.url(), this.fileName(), this.labelGroup());
  }
}
